import React from "react";

export default function FormatPill({ format, projectId }) {
  if (!format) return null;
  return (
    <span
      data-testid={projectId ? `project-format-${projectId}` : undefined}
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "5px 10px",
        borderRadius: 999,
        border: "1px solid var(--sokno-line)",
        background: "rgba(243,233,210,0.03)",
        color: "var(--sokno-cream-dim)",
        fontFamily: "'Cinzel', serif",
        fontSize: 10,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
      }}
    >
      {format}
    </span>
  );
}
